<style lang="stylus" scoped>
.describe {
  display: flex;
  justify-content: space-between;
  color: #fff;
  text-align: center;

  .left, .right {
    width: 50%;
  }

  .item {
    height: 150px;
    width: 408px;
    background: url('../../../../../static/img/helpPoor/bg1.png') no-repeat;
    background-position: 0% 20px;

    .tit {
      font-size: 28px;
      text-align: right;
      padding-right: 40px;
      box-sizing: border-box;
    }

    .data {
      font-size: 60px;
      margin-top: 30px;
      text-align: center;
    }
  }

  .detail {
    margin-top: 10px;

    .detail-item {
      font-size: 18px;
      color: rgba(0, 232, 255, 1);
      line-height: 2;
      text-align: left;
      padding-left: 24px;
      box-sizing: border-box;
    }
  }

  .right {
    .detail-item {
      padding-left: 60px;
    }
  }
}
</style>

<template>
  <div class="describe">
    <div class="left">
      <div class="item">
        <p class="tit">脱贫人数</p>
        <p class="data">{{itemData1}}</p>
      </div>
      <div class="detail">
        <div class="detail-item">电商扶贫企业数（家）：324</div>
        <div class="detail-item">电商带动贫困户数（户）：7293</div>
      </div>
    </div>
    <div class="right">
      <div class="item">
        <p class="tit">未脱贫人数</p>
        <p class="data">{{itemData2}}</p>
      </div>
      <div class="detail">
        <div class="detail-item">贫困户电商产品数（种）：19</div>
        <div class="detail-item">电商扶贫增收（元/每户）：2007</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data1: [630123, 730123, 830123],
      data2: [20045023, 10045023, 9045023],
      itemData1: 18335,
      itemData2: 2352,
      num: 0
    }
  },
  components: {
  },
  mounted() {
    // const that = this;
    // setInterval(function () {
    //   that.itemData1 = that.data1[that.num % 3]
    //   that.itemData2 = that.data2[that.num % 3]
    //   that.num++
    // }, 5000)
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?074e42cf